import { useContext, useEffect } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { AuthContext } from '../contexts/AuthContext'

/**
 * Global guard: any logged-in user whose `phone_number` is empty (typically
 * users who came in via Google/Apple before phone-completion shipped, or who
 * abandoned the flow on a previous session) is forced onto `/complete-profile`.
 *
 * Renders nothing — purely a side-effect component placed inside <BrowserRouter>.
 *
 * Allowlist: pages where we must NOT redirect to avoid trapping the user
 * mid-auth or blocking legal/help pages.
 */
const ALLOWED_PREFIXES = ['/complete-profile', '/account-login', '/create-account', '/otp-verification', '/forgot-password', '/reset-password', '/terms', '/privacy', '/contact', '/payment/success', '/payment/failed']

const isAllowed = pathname => ALLOWED_PREFIXES.some(p => pathname === p || pathname.startsWith(p + '/'))

const RequirePhoneNumber = () => {
  const { user, token } = useContext(AuthContext)
  const location = useLocation()
  const navigate = useNavigate()

  useEffect(() => {
    if (!token || !user) return // not logged in → nothing to do
    if (user.phone_number) return // phone already on file
    if (isAllowed(location.pathname)) return // on an allowlisted page

    navigate('/complete-profile', {
      replace: true,
      state: { redirectTo: location.pathname + location.search }
    })
  }, [token, user, location.pathname, location.search, navigate])

  return null
}

export default RequirePhoneNumber
